export * from '@aws-amplify/api';
//# sourceMappingURL=index.mjs.map
